document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const open = nav.hasAttribute('hidden');
  nav.toggleAttribute('hidden');
  toggle.setAttribute('aria-expanded', String(open));
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-extra-logo-option]')) {
    const panel = event.target.closest('[data-extra-logo]');
    if (event.target.checked) {
      const group = event.target.value.includes('Back') ? 'Back' : (event.target.value.includes('Sleeve') ? 'Sleeve' : '');
      if (group) {
        panel.querySelectorAll('[data-extra-logo-option]').forEach((input) => {
          if (input !== event.target && input.value.includes(group)) input.checked = false;
        });
      }
    }
    const selected = [...panel.querySelectorAll('[data-extra-logo-option]:checked')].map((input) => input.value);
    const summary = panel.querySelector('[data-extra-logo-summary]');
    if (summary) summary.textContent = selected.length ? `Selected: ${selected.join(', ')}` : 'No extra logo selected';
  }
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  const button = form && form.querySelector('[type="submit"]');
  const price = document.querySelector('[data-product-price]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.product-form');
  if (!form) return;
  const panel = form.querySelector('[data-extra-logo]');
  const selectedLogos = panel ? [...panel.querySelectorAll('[data-extra-logo-option]:checked')] : [];
  if (!panel || selectedLogos.length === 0) return;

  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const formData = new FormData(form);
  const garmentVariantId = Number(formData.get('id'));
  const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
  const placements = selectedLogos.map((input) => input.value);
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding garment and logos…';

  const items = [{
    id: garmentVariantId,
    quantity,
    properties: { 'Extra logo positions': placements.join(', ') }
  }];
  selectedLogos.forEach((input) => {
    items.push({
      id: Number(input.dataset.addonVariantId),
      quantity,
      properties: { 'Logo application': input.value, 'For garment': document.querySelector('.product-info h1')?.textContent.trim() || 'Workwear' }
    });
  });

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Could not add the items.');
    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
  } catch (error) {
    button.disabled = false;
    button.textContent = originalLabel;
    alert(error.message || 'Something went wrong. Please try again.');
  }
});
